// extracted by mini-css-extract-plugin
export default {"marginLeft":"styles_marginLeft__4QtFq"};